export enum CompanyEnum {
    BEVI = 1,
}